import React, { useContext, useEffect, useState } from 'react';
import { FirebaseContext } from '../../context/firebase';
import * as PROJECT_CODE from '../../constants/projectCode';
import * as STORAGE_BUCKET from '../../constants/storageBucket';
import defaultUser from '../../assets/defaultUser.png';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import './ThreeDHomes.css';
import ButtonBase from '@material-ui/core/ButtonBase';
import CallFurioos from '../videoCall/FurioosController';
import CancelIcon from '@material-ui/icons/Cancel';
import ClearIcon from '@material-ui/icons/Clear';
import Modal from '../layout/modal/Modal';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import { Carousel } from 'react-responsive-carousel';

function ThreeDHomes() {
	const { firebase } = useContext(FirebaseContext);
	const [furioosLink, setFurioosLink] = useState([]);
	const [matterportLink, setMatterportLink] = useState([]);
	const [show, setShow] = useState(false);
	const [files, setFiles] = useState([]);
	const [showModal, setShowModal] = useState(false);

	useEffect(() => {
		firebase.auth().onAuthStateChanged(function (user) {
			if (user) {
				firebase
					.database()
					.ref('/kavtek_clients/' + PROJECT_CODE.projectCode)
					.once('value', (snapshot) => {
						var furSnap = snapshot.child('furioos');
						var mattSnap = snapshot.child('matterport');
						var furioosPresentations = [];

						let furLink;
						let mattLink;

						function sortByProperty(property) {
							return function (a, b) {
								if (a[property] < b[property]) return 1;
								else if (a[property] > b[property]) return -1;

								return 0;
							};
						}

						//get the list of presentations for furioos
						if (furSnap != null || furSnap !== undefined) {
							furSnap.forEach((element) => {
								var furioosId = element.val().id;
								var furioosName = element.val().name;
								var furPose = element.key;
								function getImageLinkForFurioos(callback) {
									var imageRef = firebase
										.storage()
										.refFromURL(
											'gs://' +
												STORAGE_BUCKET.storageBucket +
												'.appspot.com/' +
												PROJECT_CODE.projectCode +
												'/' +
												furioosId +
												'.jpg'
										);

									imageRef
										.getDownloadURL()
										.then((url) => {
											callback(url);
										})
										.catch((error) => {
											console.log(error);
										});
								}

								getImageLinkForFurioos(function (imageLink) {
									furLink = {
										id: furioosId,
										imageUrl: imageLink,
										name: furioosName,
										position: furPose,
									};
									console.log('FUR POSE ' + furPose);
									furioosPresentations.push(furLink);
									// furioosPresentations.sort((a, b) =>{
									// 	return a.position < b.position;
									// });
									furioosPresentations.sort(sortByProperty('position'));
									console.log('Sorted fur Pose');
									setFurioosLink([...furioosPresentations]);
								});
								console.log('furLink ' + furLink);
								console.log('furioosPresentations' + furioosPresentations);
							});
						}

						if (mattSnap != null || mattSnap !== undefined) {
							let matterportPresentations = [];
							mattSnap.forEach((element) => {
								var matterportId = element.key;

								function getImageLinkForMatterport(callback) {
									var imageRef = firebase
										.storage()
										.refFromURL(
											'gs://' +
												STORAGE_BUCKET.storageBucket +
												'.appspot.com/' +
												PROJECT_CODE.projectCode +
												'/' +
												matterportId +
												'.jpg'
										);

									imageRef
										.getDownloadURL()
										.then((url) => {
											callback(url);
										})
										.catch((error) => {
											console.log(error);
										});
								}

								getImageLinkForMatterport(function (imageLink) {
									mattLink = {
										id: matterportId,
										url: element.val().url,
										name: element.val().name,
										imageUrl: imageLink,
									};

									matterportPresentations.push(mattLink);
									console.log(mattLink);
									setMatterportLink([...matterportPresentations]);
								});
							});
						}
					});
			}
		});
	}, []);

	const handleFurioos = (e) => {
		var projectId = e.currentTarget.dataset.id;

		var furioosCaller = new CallFurioos();

		async function furioos() {
			await setShow(true);

			var currentUserId = firebase.auth().currentUser.uid;
			var userEmail;
			var userName;
			var userTime = Date.now();
			await firebase
				.database()
				.ref('users')
				.child(currentUserId)
				.once('value', (snapshot) => {
					userEmail = snapshot.val().email;
					userName = snapshot.val().displayName;
				});

			await furioosCaller.startFurioos(
				userEmail,
				userName,
				'',
				'e5fe5968-058c-494b-8e8f-ca95425a2a02',
				userTime,
				'',
				'admin',
				currentUserId,
				currentUserId,
				'',
				'furioosContainer_homes',
				projectId
			);
		}

		furioos();

		console.log('projectId: ' + projectId);
	};

	const handleClose = () => {
		setShow(false);
	};

	const handleTwoDHomes = (e) => {
		setShowModal(true);
		var id = e.currentTarget.dataset.id;
		var i = 0;
		var storageRef = firebase.storage().ref(PROJECT_CODE.projectCode);

		storageRef
			.child(id)
			.listAll()
			.then(function (result) {
				result.items.forEach(function (imageRef) {
					i++;
					displayImage(i, imageRef);
				});
			});

		var imageArr = [];
		var imageUrl;
		function displayImage(i, images) {
			images.getDownloadURL().then(function (url) {
				console.log('The urls are : ' + url);

				imageUrl = url;
				imageArr.push(url);
				setFiles([...imageArr]);
			});
		}
	};

	const closeModalHandler = () => {
		setShowModal(false);
	};

	const useStyles = makeStyles({
		cardsGroup: {
			display: 'flex',
			flexWrap: 'wrap',
		},
		root: {
			width: 400,
			margin: 10,
		},
		media: {
			height: 250,
		},
		cardArea: {
			pointerEvents: 'none',
		},
	});

	const styles = useStyles();

	return (
		<>
			{/* {show && (
				<div className='cancelBtn' onClick={handleClose}>
					<CancelIcon className='cancelIcon' />
				</div>
			)} */}
			{show && (
				<div id='furioosContainer_homes'>
					<div className='cancelBtn' onClick={handleClose}>
						<ClearIcon className='cancelIcon' />
					</div>
				</div>
			)}
			<div className='threeDHomes-page'>
				<h2 id='three-title'>3D Virtual Tours</h2>
				{console.log('URLS IN MY PARTY: ' + files)}

				{!show && (
					<div className={styles.cardsGroup}>
						{furioosLink?.map((link) => {
							return (
								<Card
									key={link.imageUrl}
									className={styles.root}
									data-id={link.id}
								>
									<CardActionArea className={styles.cardArea}>
										<CardMedia
											className={styles.media}
											image={link.imageUrl}
											title='Contemplative Reptile'
										/>
										<CardContent>
											<Typography gutterBottom variant='h5' component='h2'>
												{link.name}
											</Typography>
										</CardContent>
									</CardActionArea>
									<CardActions>
										<button
											className='btn btn-primary'
											data-id={link.id}
											onClick={handleFurioos}
										>
											View 3D Model
										</button>
										{/* <button
											className='btn btn-primary'
											data-id={link.id}
											onClick={handleTwoDHomes}
										>
											View 2D Model
										</button> */}
									</CardActions>
								</Card>
							);
						})}
						{matterportLink?.map((link) => {
							return (
								<Card key={link.url} className={styles.root}>
									<CardActionArea className={styles.cardArea}>
										<CardMedia
											className={styles.media}
											image={link.imageUrl}
											title='Contemplative Reptile'
										/>
										<CardContent>
											<Typography gutterBottom variant='h5' component='h2'>
												{link.name}
											</Typography>
										</CardContent>
									</CardActionArea>
									<CardActions>
										<button
											className='btn btn-primary'
											onClick={() => window.open(link.url)}
										>
											View 3D Model
										</button>
										{/* <button
											className='btn btn-primary'
											data-id={link.id}
											onClick={handleTwoDHomes}
										>
											View 2D Model
										</button> */}
									</CardActions>
								</Card>
							);
						})}
					</div>
				)}

				{showModal === true && (
					<div className='back-drop' onClick={closeModalHandler}></div>
				)}
				<Modal
					show={showModal}
					close={closeModalHandler}
					title='2D Home View'
					buttonName='Close'
					button={closeModalHandler}
				>
					<Carousel
						autoPlay={false}
						showArrows={true}
						centerMode={false}
						swipeable={true}
						showStatus={false}
						emulateTouch={true}
						infiniteLoop={true}
						showThumbs={true}
					>
						{files?.map((image) => {
							return <img src={image} alt='' />;
						})}
					</Carousel>
				</Modal>
			</div>
		</>
	);
}

export default ThreeDHomes;
